





































import moment from 'moment';
import { ModalSize } from '@getaccept/lib-ui';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import type { PropType } from '@vue/composition-api';
import { defineComponent, computed } from '@vue/composition-api';
import type { DocumentRecipientRevision } from '../types/document-revision';

export default defineComponent({
  props: {
    visible: {
      type: Boolean,
    },
    documentName: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    sender: {
      type: String,
      default: '',
    },
    latestRevision: {
      type: Object as PropType<DocumentRecipientRevision>,
      default: null,
    },
    loading: {
      type: Boolean,
    },
  },
  setup(props) {
    const day = computed(() =>
      moment(props.latestRevision?.createdAt).calendar({
        sameDay: '[Today]',
        lastDay: '[Yesterday]',
        lastWeek: '[Last] dddd',
        sameElse: 'DD/MM/YYYY',
      })
    );

    const time = computed(() => moment(props.latestRevision?.createdAt).format('LT'));

    const message = computed(() => props.latestRevision?.message);

    return {
      ModalSize,
      t,
      day,
      time,
      message,
    };
  },
});
